export default "__VITE_ASSET__BpN5RouF__"